import { Config } from "@/config";
import * as signalR from "@microsoft/signalr";
import { Store } from "vuex";
import { ToastNotification } from "../ToastNotification";
import { TYPES } from "@/types";
import { injectable, inject } from "inversify";
import { ISignalRService } from "@/interfaces/ISignalR";
import { INotificationItem } from "@/features/notifications/models/Notifications";

export type Callback = (message: INotificationItem) => void;

@injectable()
export class SignalRBuilder implements ISignalRService {
  private store: Store<any>;

  constructor(@inject("Store") store: Store<any>) {
    this.store = store;
  }
  async send(payLoad: any): Promise<any> {
    console.log(this.IsConnected, "connected?", payLoad, this.connection);
    await this.connection.invoke("test", payLoad);
  }
  private callbacks: Map<string, Callback> = new Map();
  connection: signalR.HubConnection;
  ContainerId: number;
  IsConnected: boolean;
  test(containerId: number, token: string): void {
    this.ContainerId = containerId;
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(TYPES.BaseURL + "/notifications", {
        accessTokenFactory: () => token,
      })
      .build();
  }
  private build(): void {
    this.connection.on("Notification", (message) => {
      this.callbacks.forEach((callback) => {
        if (typeof message === "object" && message !== null) {
          callback(message);
        }
      });
    });

    this.connection.on("Exception", (message) => {
      this.store.dispatch(
        "addNotification",
        new ToastNotification("error", message)
      );
    });
    this.connection.on("SendToGroup", (message) => {
      console.log(message);
    });
  }
  public registerCallback(callback: Callback): string {
    const id = this.generateUniqueId();
    this.callbacks.set(id, callback);
    return id;
  }
  public removeCallback(id: string): void {
    this.callbacks.delete(id);
  }

  private generateUniqueId(): string {
    // Simple ID generation. Consider more robust methods for real-world use.
    return Date.now().toString(36) + Math.random().toString(36).substr(2);
  }
  async start() {
    this.build();
    try {
      if (this.IsConnected) return;
      await this.connection.start();
      this.IsConnected = true;
      await this.connection.send("Join", this.ContainerId);
      console.log("connected");
    } catch (e) {
      console.log(e, "signalrBuilder");
    }
  }
}
